// Imports => Constants
import { ENDPOINTS } from '@constants';

export class MovementsAPI {
  constructor(Client, config) {
    this.Client = Client;
    this.config = config;
  }

  list = (params) => {
    return this.Client.get(ENDPOINTS.MOVEMENTS.LIST, { params }).then(
      (response) => response.data
    );
  };

  get_by_id = (uid, params) => {
    return this.Client.get(ENDPOINTS.MOVEMENTS.GET_BY_ID(uid), {
      params,
    }).then((response) => response.data.data);
  };

  get_parent_payment_methods = (uids) => {
    return this.Client.post(ENDPOINTS.MOVEMENTS.GET_PAYMENT_METHODS(), {
      uids,
    }).then((response) => response.data.data);
  };
}

export default MovementsAPI;
